//@ts-check
import React from 'react';

var SingleElementIcon = function SingleElementIcon() {
  return React.createElement("svg", {
    viewBox: "0 0 32 32",
    height: "14",
    width: "14"
  }, React.createElement("path", {
    d: "M5.167 12.433h21.333q0.56 0 0.947 0.387t0.387 0.947v5.333q0 0.56-0.387 0.947t-0.947 0.387h-21.333q-0.56 0-0.947-0.387t-0.387-0.947v-5.333q0-0.56 0.387-0.947t0.947-0.387z"
  }));
};

var RepeatingElementIcon = function RepeatingElementIcon() {
  return React.createElement("svg", {
    viewBox: "0 0 32 32",
    height: "14",
    width: "14"
  }, React.createElement("path", {
    d: "M3.333 2.767h25.333q0.267 0 0.467 0.2t0.2 0.467v4q0 0.267-0.2 0.467t-0.467 0.2h-25.333q-0.267 0-0.467-0.2t-0.2-0.467v-4q0-0.267 0.2-0.467t0.467-0.2zM3.333 13.433h25.333q0.267 0 0.467 0.2t0.2 0.467v4q0 0.267-0.2 0.467t-0.467 0.2h-25.333q-0.267 0-0.467-0.2t-0.2-0.467v-4q0-0.267 0.2-0.467t0.467-0.2zM3.333 24.1h25.333q0.267 0 0.467 0.2t0.2 0.467v4q0 0.267-0.2 0.467t-0.467 0.2h-25.333q-0.267 0-0.467-0.2t-0.2-0.467v-4q0-0.267 0.2-0.467t0.467-0.2z"
  }));
};

var MultipleOutputIcon = function MultipleOutputIcon() {
  return React.createElement("svg", {
    viewBox: "0 0 32 32",
    height: "14",
    width: "14"
  }, React.createElement("path", {
    d: "M23.5 11.625h7.5v14.375q0 0.25-0.188 0.437t-0.437 0.188h-9.375v-14.775l-7.5-7.5v-2.1q0-0.25 0.188-0.437t0.437-0.188h9.375v10zM31 9.125h-5v-5zM11 16.625h7.5v14.375q0 0.25-0.188 0.437t-0.437 0.188h-16.25q-0.25 0-0.437-0.188t-0.188-0.437v-23.75q0-0.25 0.188-0.437t0.437-0.188h9.375v10zM18.5 14.125h-5v-5z"
  }));
};

var FieldIcon = function FieldIcon() {
  return React.createElement("svg", {
    viewBox: "0 0 32 32",
    height: "14",
    width: "14",
    fill: "yellowgreen"
  }, React.createElement("path", {
    d: "M29.429 16q0 3.732-1.839 6.884t-4.991 4.991-6.884 1.839-6.884-1.839-4.991-4.991-1.839-6.884 1.839-6.884 4.991-4.991 6.884-1.839 6.884 1.839 4.991 4.991 1.839 6.884z"
  }));
};

var DataIcon = function DataIcon(props) {
  switch (props.type) {
    case 'single-element':
      return React.createElement(SingleElementIcon, null);

    case 'split-element':
      return React.createElement(MultipleOutputIcon, null);

    case 'multiple-element':
      return React.createElement(RepeatingElementIcon, null);

    default:
      return React.createElement(FieldIcon, null);
  }
};

export default DataIcon;